import type { PublishStatus, RecordingStatus } from "../types/api";

const RECORDING_LABELS: Record<RecordingStatus, { label: string; className: string }> = {
  pending_approval: { label: "In review", className: "pill-pending" },
  approved: { label: "Approved", className: "pill-approved" },
  rerecord: { label: "Re-record", className: "pill-rerecord" },
  rejected: { label: "Not accepted", className: "pill-rejected" },
  superseded: { label: "Replaced", className: "" },
};

export function StatusPill({ status }: { status: RecordingStatus }) {
  const entry = RECORDING_LABELS[status] ?? { label: status, className: "" };
  return <span className={`pill ${entry.className}`}>{entry.label}</span>;
}

/**
 * Only shown once something is actually live. The intermediate states are
 * ours to worry about, not the contributor's — they are paid either way.
 */
export function PublishPill({ status }: { status: PublishStatus }) {
  if (status !== "published") return null;
  return <span className="pill pill-live">On air</span>;
}
